// Provider info for direct pay link
export interface IDirectPayLinkProvider {
  id: string;
  name: string;
}

export interface IDirectPayLink {
  id: string;
  shortId: string;
  accountId: string;
  cptCode: string;
  cptDescription?: string;
  amountInCents: number | null;
  amountEditable: boolean;
  showAccountNumber: boolean;
  showProviderName: boolean;
  providers?: IDirectPayLinkProvider[]; // Selected providers for this link
  header?: string | null;
  subheader?: string | null;
  maxOrders: number;
  ordersCreated: number;
  expiresAt: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdByUserId: string;
  isMain: boolean;
}

export interface IDirectPayLinkCreateRequest {
  accountId: string;
  cptCode: string;
  cptDescription?: string;
  amountInCents: number | null;
  amountEditable: boolean;
  showAccountNumber: boolean;
  showProviderName: boolean;
  providerIds?: string[]; // Provider IDs to associate with this link
  header?: string | null;
  subheader?: string | null;
  maxOrders?: number | null;
  expiresAt?: string | null;
  isMain: boolean;
}

export interface IDirectPayLinkUpdateRequest {
  cptCode?: string;
  cptDescription?: string;
  amountInCents?: number | null;
  amountEditable?: boolean;
  showAccountNumber?: boolean;
  showProviderName?: boolean;
  providerIds?: string[]; // Provider IDs to associate with this link
  header?: string | null;
  subheader?: string | null;
  maxOrders?: number | null;
  expiresAt?: string | null;
  isActive?: boolean;
}

export interface IDirectPayLinkResponse {
  success: boolean;
  data: IDirectPayLink;
  message?: string;
}

export interface IDirectPayLinksResponse {
  success: boolean;
  data: IDirectPayLink[];
  message?: string;
}

export interface IDirectPayLinkPublicConfig {
  shortId: string;
  accountId: string;
  cptCode: string;
  cptDescription?: string;
  amountInCents: number | null;
  amountEditable: boolean;
  showAccountNumber: boolean;
  showProviderName: boolean;
  providers: IDirectPayLinkProvider[]; // Available providers for selection
  header?: string | null;
  subheader?: string | null;
  isActive: boolean;
  isExpired: boolean;
  ordersCreated: number;
  maxOrders: number;
  accountLogoUrl: string | null; // Hospital logo for public display
}

export interface IDirectPayLinkPublicResponse {
  success: boolean;
  data: IDirectPayLinkPublicConfig;
  message?: string;
}

export enum DirectPayLinkStatus {
  ACTIVE = "Active",
  EXPIRED = "Expired",
  DEACTIVATED = "Deactivated",
}
